// Gestione centralizzata dei meta tag SEO per ogni pagina e lingua.
// Viene eseguita a runtime e finisce anche negli snapshot pre-renderizzati
// (react-snap), quindi crawler e social vedono title/description/canonical/
// hreflang corretti per ogni URL.

const BASE = "https://www.studioprojectworks.com";

const META = {
  "/": {
    it: {
      title: "Project Works | Studio Tecnico Associato — Progettazione, Rilievi, Direzione Lavori",
      description:
        "Project Works è uno Studio Tecnico Associato a Nizza Monferrato (AT): progettazione edilizia, rilievi topografici, direzione lavori e consulenze tecniche. Richiedi un preventivo.",
    },
    en: {
      title: "Project Works | Associated Technical Studio — Design, Surveys, Construction Management",
      description:
        "Project Works is an associated technical studio in Nizza Monferrato (AT), Italy: building design, topographic surveys, construction management and technical consulting. Request a quote.",
    },
  },
  "/privacy-policy/": {
    it: {
      title: "Privacy Policy | Project Works — Studio Tecnico Associato",
      description: "Privacy Policy di Project Works — Studio Tecnico Associato, Nizza Monferrato (AT).",
    },
    en: {
      title: "Privacy Policy | Project Works — Associated Technical Studio",
      description: "Privacy Policy of Project Works — Associated Technical Studio, Nizza Monferrato (AT), Italy.",
    },
  },
  "/cookie-policy/": {
    it: {
      title: "Cookie Policy | Project Works — Studio Tecnico Associato",
      description: "Cookie Policy di Project Works — Studio Tecnico Associato, Nizza Monferrato (AT).",
    },
    en: {
      title: "Cookie Policy | Project Works — Associated Technical Studio",
      description: "Cookie Policy of Project Works — Associated Technical Studio, Nizza Monferrato (AT), Italy.",
    },
  },
};

// Percorso canonico: le pagine legali sono directory reali, il canonical ha lo slash finale
const canonicalPath = (pathname) => {
  if (pathname === "/") return "/";
  if (pathname === "/en" || pathname === "/en/") return "/en/";
  return pathname.endsWith("/") ? pathname : `${pathname}/`;
};

const upsertMeta = (attr, key, content) => {
  let el = document.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
};

const upsertLink = (rel, href) => {
  let el = document.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", rel);
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
};

const upsertHreflang = (lang, href) => {
  let el = document.querySelector(`link[hreflang="${lang}"]`);
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", "alternate");
    el.setAttribute("hreflang", lang);
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
};

export function applyHeadMeta(pathname, lang) {
  const cp = canonicalPath(pathname);
  const key = cp === "/" || cp === "/en/" ? "/" : cp.replace(/^\/en/, "");
  const m = META[key]?.[lang];

  document.documentElement.lang = lang;
  if (m) {
    document.title = m.title;
    upsertMeta("name", "description", m.description);
    upsertMeta("property", "og:title", m.title);
    upsertMeta("property", "og:description", m.description);
  }
  upsertLink("canonical", BASE + cp);
  upsertMeta("property", "og:url", BASE + cp);
  upsertMeta("property", "og:locale", lang === "en" ? "en_US" : "it_IT");
  upsertMeta("property", "og:site_name", lang === "en" ? "Project Works — Associated Technical Studio" : "Project Works — Studio Tecnico Associato");

  const itPath = cp.replace(/^\/en/, "") || "/";
  const enPath = itPath === "/" ? "/en/" : `/en${itPath}`;
  upsertHreflang("it", BASE + itPath);
  upsertHreflang("en", BASE + enPath);
  upsertHreflang("x-default", BASE + itPath);
}
